import React from 'react';
import TimelineGroupBlock from './TimelineGroupBlock';
import { timelineGroups } from '../../constants/processData';
import FadeIn from '../common/FadeIn';

const ProjectTimeline = () => {
  return (
    <div className="w-full bg-[#f9f9f5] py-12 md:py-20 px-6 md:px-12 text-[#2c231b]">
      <FadeIn className="text-center mb-10 md:mb-12">
        <h3 className="font-PromenadeItalic font-normal leading-[1.2] tracking-[0em] text-[31px] md:text-[36px]">
          Project Timeline
        </h3>
      </FadeIn>

      <div className="relative max-w-4xl mx-auto">
        <div className="hidden md:block absolute left-1/2 top-2 bottom-2 w-[1px] bg-[#83776966] -translate-x-1/2"></div>
        <div className="md:hidden absolute left-3 top-2 bottom-2 w-[1px] bg-[#83776966]"></div>

        {timelineGroups.map((group, groupIndex) => (
          <TimelineGroupBlock
            key={groupIndex}
            group={group}
            groupIndex={groupIndex}
            totalGroups={timelineGroups.length}
          />
        ))}
      </div>

      <FadeIn className="text-center mt-16 md:mt-24">
        <p className="font-PromenadeItalic text-[18px] leading-[1.2] tracking-[0em] font-normal md:text-[23px] w-[270px] max-w-[270px] md:w-auto md:max-w-md mx-auto">
          Timeline may vary based on project scope, custom orders, and architectural elements.
        </p>
      </FadeIn>
    </div>
  );
};

export default ProjectTimeline;
